const shape = {
    borderRadius: 0,
    borderRadiusSm: 12,
    borderRadiusMd: 16,
};
  
export default shape;